import { Vue, Component, Inject } from 'vue-property-decorator';
import WorkOrdersService from "@/apis/prev-orders";
// @ts-ignore
import { DateTime } from "luxon";

@Component({

})

export default class previousOrdersComponents extends Vue {
	@Inject('workOrdersService') private workOrdersService!: () => WorkOrdersService;

	public prevOrders: any[] = [];

	async mounted() {
		const ordersRequest = {
			"securityToken": this.$store.getters.token,
			"clientID": this.$store.getters.clientId,
			"pageNo": "1",
			"pageSize": "999",
			"sortMode": "1",
			"sortDirection": "1",
			"isCompleteObject": "true"
		}
		this.$store.commit('setOverlay', true)
		const ordersResponse = await this.workOrdersService().getListOfWorkOrdersForAClient(ordersRequest)
		this.$store.commit('setOverlay', false)
		// @ts-ignore
		const filteredWorkOrders = ordersResponse.WorkOrders.filter(order => {			
			return order.title[order.title.length - 1] === "1";
		}).sort((a: any, b: any) => {
			const dateA = new Date(+a.dateService)
			const dateB = new Date(+b.dateService);
			// @ts-ignore
			return dateA - dateB;
		});
		const otherWorkOrders = ordersResponse.WorkOrders.filter((order: any) => {
			return order.title[order.title.length - 1] === "2";
		}).sort((a: any, b: any) => {
			const dateA = new Date(+a.dateService)
			const dateB = new Date(+b.dateService);
			// @ts-ignore
			return dateA - dateB;
		});
		filteredWorkOrders.forEach((order: any, index: number) => {
			this.prevOrders[index] = {
				id: order.objectID,
				waste: "General Household Items",
				pickupDate: DateTime.fromMillis(+order.dateService * 1000).toLocaleString(DateTime.DATE_FULL),
			};
			order.Fields.forEach((field: any) => {
				switch (field.fieldID) {
					case 181:
						this.prevOrders[index].status = field.fieldValue;
						break;
					case 200:
						this.prevOrders[index].description = field.fieldValue;
						break;
					case 813:
						this.prevOrders[index].price = field.fieldValue;
						break;
					case 187:
						this.prevOrders[index].subtotal = field.fieldValue;
						break;
					case 9835:
						this.prevOrders[index].total = field.fieldValue;
						break;
					default:
						break;
				}

			});
			if (this.prevOrders[index].total && this.prevOrders[index].subtotal) {
				//@ts-ignore
				this.prevOrders[index].tax = (this.prevOrders[index].total - this.prevOrders[index].subtotal).toFixed([2])
			}
			if (this.prevOrders[index].subtotal && this.prevOrders[index].price) {
				//@ts-ignore
				this.prevOrders[index].discount = (this.prevOrders[index].subtotal - this.prevOrders[index].price).toFixed([2])
			}
			order.Relations.forEach((relation: any) => {
				if (relation.objectTypeID === 20) {
					this.prevOrders[index].location = relation.name;
				}
				if (relation.objectTypeID === 10) {
					this.prevOrders[index].taskId = relation.name;
				}
			});
		});
		otherWorkOrders.forEach((order: any) => {
			this.prevOrders.find(item => item.taskId === order.Relations.find((rel: any) => rel.objectTypeID === 10).name).dropDate = DateTime.fromMillis(+order.dateService * 1000).toLocaleString(DateTime.DATE_FULL);
		});
		this.prevOrders = [...this.prevOrders];
	}
}
